export const BASENAME = window.location.pathname.startsWith("/gestao") ? "/gestao" : "";
